import classNames from 'classnames'
import * as React from 'react'

import { Colour } from 'components/variables'

import './ButtonGroup.scss'

export enum ButtonGroupType {
  pagination = 'pagination',
  contactOptions = 'contactOptions',
  transportToggle = 'transportToggle',
  newTransportToggle = 'newTransportToggle',
}

interface ButtonGroupProps {
  id?: string
  type?: ButtonGroupType
  noTransform?: boolean
  colour?: Colour
  children?: React.ReactNode | undefined
}

const ButtonGroup: React.FC<ButtonGroupProps> = props => {
  const className = classNames(
    'srprs-buttonGroup',
    props.type ? `type-${props.type}` : '',
    props.noTransform ? `no-transform` : '',
    props.colour,
  )

  return (
    <div id={props.id} className={className}>
      {props.children}
    </div>
  )
}

export default ButtonGroup
